import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { Icon, IconButton } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

const styles = ({
  palette: {
    common: { white },
  },
  spacing: { unit },
  custom: {
    palette: { colorSupportMidnight },
  },
}) => ({
  buttonClose: {
    color: white,
    float: 'right',
  },
  leftIcon: {
    marginRight: unit,
    color: white,
    verticalAlign: 'text-bottom',
  },
  title: {
    color: white,
    display: 'inline-block',
    lineHeight: '48px',
    whiteSpace: 'nowrap',
  },
  wrapper: {
    backgroundColor: colorSupportMidnight,
    padding: unit * 2,
    paddingLeft: `${unit * 3}px !important`,
  },
});

class DialogHeader extends PureComponent {
  renderCloseButton(style) {
    const { classes, onRequestClose } = this.props;

    if (!onRequestClose) return;

    return (
      <IconButton
        data-lh-id="dialog-header-close"
        className={classes.buttonClose}
        onClick={onRequestClose}
        style={style}
      >
        <CloseIcon />
      </IconButton>
    );
  }

  renderLeftIcon(style) {
    const { classes, leftIcon } = this.props;

    if (!leftIcon && leftIcon === '') return;

    return (
      <Icon className={classes.leftIcon} style={style}>
        {leftIcon}
      </Icon>
    );
  }

  render() {
    const { backgroundColor, classes, color, title } = this.props;
    const containerStyle = {};
    const titleStyle = {};

    if (backgroundColor) containerStyle.backgroundColor = backgroundColor;
    if (color) titleStyle.color = color;

    return (
      <div className={classes.wrapper} style={containerStyle}>
        {this.renderLeftIcon(titleStyle)}
        <Typography className={classes.title} style={titleStyle} variant="h6">
          {title}
        </Typography>
        {this.renderCloseButton(titleStyle)}
      </div>
    );
  }
}

DialogHeader.propTypes = {
  backgroundColor: PropTypes.string,
  classes: PropTypes.object.isRequired,
  color: PropTypes.string,
  leftIcon: PropTypes.string,
  onRequestClose: PropTypes.func,
  title: PropTypes.string.isRequired,
};

DialogHeader.defaultProps = {
  backgroundColor: '',
  color: '',
  leftIcon: '',
};

export default withStyles(styles)(DialogHeader);
